"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionFeePricingStrategy = exports.PaymentsPricingMode = void 0;
var PaymentsPricingMode;
(function (PaymentsPricingMode) {
    /** Manual/bespoke billing; automated Payments Only fee calculation is skipped. */
    PaymentsPricingMode["BESPOKE"] = "bespoke";
    /** Usage is not billed; the company subscription is charged one fixed monthly fee. */
    PaymentsPricingMode["MONTHLY_FEE"] = "monthly_fee";
    /** Each enabled payment currency and type is billed by explicit fee rules. */
    PaymentsPricingMode["RULE_BASED"] = "rule_based";
})(PaymentsPricingMode = exports.PaymentsPricingMode || (exports.PaymentsPricingMode = {}));
/** Pricing calculation strategy for one payable-type rule in Rule Based pricing. */
var SubscriptionFeePricingStrategy;
(function (SubscriptionFeePricingStrategy) {
    /** Use the standard Payments Only tiered catalogue. Allowed for UK Single Payments only. */
    SubscriptionFeePricingStrategy["STANDARD_TIERED"] = "standard_tiered";
    /** Use the high-risk Payments Only tiered catalogue. Allowed for UK Single Payments only. */
    SubscriptionFeePricingStrategy["HIGH_RISK_TIERED"] = "high_risk_tiered";
    /** Use a fixed monthly Bulk Payments plan. */
    SubscriptionFeePricingStrategy["FIXED_MONTHLY_PLAN"] = "fixed_monthly_plan";
    /** Use explicit flat/percentage custom fees from this rule. */
    SubscriptionFeePricingStrategy["CUSTOM_FEES"] = "custom_fees";
    /** Used for Recurring Payments to charge a fixed fee per 1 Recurring Payment setup. */
    SubscriptionFeePricingStrategy["PER_SETUP_FEE"] = "per_setup_fee";
})(SubscriptionFeePricingStrategy = exports.SubscriptionFeePricingStrategy || (exports.SubscriptionFeePricingStrategy = {}));
